// extracted by mini-css-extract-plugin
export default {"markdown":"MarkdownTabContent_markdown__nUdVu"};